import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { CheckCircle2, Clock, XCircle, Loader2 } from "lucide-react";
import { api, brl } from "@/lib/api";

export default function PaymentResult() {
  const { result } = useParams();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const orderNumber = params.get("pedido");
  const [info, setInfo] = useState(null);
  const [state, setState] = useState(result === "cancelado" ? "cancelled" : "checking");

  useEffect(() => {
    if (result === "cancelado") return;
    const url = sessionId ? `/payments/stripe/status/${sessionId}` : orderNumber ? `/payments/mercadopago/status/${orderNumber}` : null;
    if (!url) return setState("error");
    let attempts = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(url);
        setInfo(data);
        if (data.payment_status === "paid") return setState("paid");
      } catch {
        return setState("error");
      }
      attempts += 1;
      if (attempts >= 10) return setState("pending");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [result, sessionId, orderNumber]);

  const number = info?.order_number || orderNumber;
  const views = {
    checking: [Loader2, "text-sky-600 animate-spin", "Confirmando pagamento...", "Aguarde alguns segundos."],
    paid: [CheckCircle2, "text-green-600", "Pagamento aprovado!", "Seu pedido foi confirmado e logo entrará em produção."],
    pending: [Clock, "text-amber-500", "Pagamento pendente", "Assim que o pagamento for confirmado, o status do pedido será atualizado."],
    cancelled: [XCircle, "text-slate-400", "Pagamento não concluído", "Seu pedido foi registrado. Você pode pagar depois pela página de rastreio."],
    error: [XCircle, "text-red-500", "Não encontramos este pagamento", "Consulte seu pedido pela página de rastreio."],
  };
  const [Icon, cls, title, text] = views[state];

  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center" data-testid="payment-result">
      <Icon className={`mx-auto h-14 w-14 ${cls}`} />
      <h1 className="mt-6 font-display text-3xl font-extrabold" data-testid="payment-result-title">{title}</h1>
      <p className="mt-2 text-slate-600">{text}</p>
      {number && (
        <div className="mt-8 rounded-md border border-slate-200 bg-white p-6">
          <p className="text-xs uppercase tracking-wider text-slate-400">Número do pedido</p>
          <p className="font-mono text-2xl font-bold" data-testid="payment-order-number">#{number}</p>
          {info && <p className="mt-1 text-sm text-slate-500">{brl(info.total)} · {info.status}</p>}
        </div>
      )}
      <Link to={`/rastrear${number ? `?numero=${number}${info?.email ? `&email=${encodeURIComponent(info.email)}` : ""}` : ""}`}
        className="mt-8 inline-flex h-12 items-center rounded-full bg-slate-900 px-7 font-bold text-white hover:bg-[#0099DD]" data-testid="btn-track-order">
        Acompanhar pedido
      </Link>
    </div>
  );
}
